import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { CompanyEntity } from './company.entity';
import { ItemEntity } from './item.entity';

@Index('idx_item_purchased_together_source_company', [
	'fkItemIdSource',
	'fkCompanyId',
])
@Index('idx_item_purchased_together_source_lift', [
	'fkItemIdSource',
	'fkCompanyId',
	'lift',
])
@Index('idx_item_purchased_together_source_cosine', [
	'fkItemIdSource',
	'fkCompanyId',
	'cosine',
])
@Index(
	'uq_item_purchased_together_pair',
	['fkItemIdSource', 'fkItemIdTarget', 'fkCompanyId'],
	{ unique: true },
)
@Entity('item_purchased_together')
export class ItemPurchasedTogetherEntity extends BaseEntity {
	@Column('int', { name: '_fk_item__id_source', unsigned: true })
	public fkItemIdSource!: number;

	@Column('int', { name: '_fk_item__id_target', unsigned: true })
	public fkItemIdTarget!: number;

	@Column('int', { name: '_fk_company__id', unsigned: true })
	public fkCompanyId!: number;

	@Column('int', { name: 'coOccurrenceCount', unsigned: true, default: 0 })
	public coOccurrenceCount!: number;

	@Column('int', { name: 'sourceOrderCount', unsigned: true, default: 0 })
	public sourceOrderCount!: number;

	@Column('int', { name: 'targetOrderCount', unsigned: true, default: 0 })
	public targetOrderCount!: number;

	@Column('int', { name: 'totalOrders', unsigned: true, default: 0 })
	public totalOrders!: number;

	@Column('decimal', {
		name: 'support',
		precision: 10,
		scale: 8,
		default: 0,
	})
	public support!: string;

	@Column('decimal', {
		name: 'confidence',
		precision: 10,
		scale: 8,
		default: 0,
	})
	public confidence!: string;

	@Column('decimal', {
		name: 'lift',
		precision: 10,
		scale: 4,
		default: 0,
	})
	public lift!: string;

	/**
	 * Cosine similarity: coOccurrenceCount / sqrt(sourceOrderCount ·
	 * targetOrderCount). Bounded to (0, 1], popularity-aware, and symmetric, so
	 * it doesn't over-reward rare pairs the way raw lift does (PD-14016). This is
	 * the primary ranking signal for the kept top-N associations; lift is kept as
	 * a secondary signal. It's also the per-pair similarity the account
	 * recommender sums over.
	 */
	@Column('decimal', {
		name: 'cosine',
		precision: 10,
		scale: 8,
		default: 0,
	})
	public cosine!: string;

	@Column('date', { name: 'periodStartDate' })
	public periodStartDate!: string;

	@Column('date', { name: 'periodEndDate' })
	public periodEndDate!: string;

	@Column('datetime', { name: 'lastCalculatedAt', precision: 0 })
	public lastCalculatedAt!: Date;

	@ManyToOne(() => ItemEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: '_fk_item__id_source', referencedColumnName: 'id' }])
	public sourceItem!: ItemEntity;

	@ManyToOne(() => ItemEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: '_fk_item__id_target', referencedColumnName: 'id' }])
	public targetItem!: ItemEntity;

	@ManyToOne(() => CompanyEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_company__id', referencedColumnName: 'id' }])
	public company!: CompanyEntity;
}
